/*
 * @Description:销售订单相关
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const ORDER = {
  path: '/order',
  name: 'order',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'order-list' },
  meta: {
    title: '订单',
    requiresAuth: true,
    // hideChildrenInMenu: true,
    roles: 'saleOrderParent',
    order: 4
  },
  children: [
    {
      path: 'list',
      name: 'order-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'order-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'saleOrder',
        title: '销售订单'
      },
      children: [
        {
          path: '',
          name: 'order-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 10 },
          meta: {
            requiresAuth: true,
            title: '销售订单',
            roles: 'saleOrder:view'
          }
        },
        {
          path: ':id/collaborators',
          name: 'return-order-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 10 },
          meta: {
            requiresAuth: true,
            title: '销售订单详情',
            roles: 'saleOrder:view'
          }
        },
        {
          path: ':id',
          name: 'order-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 10 },
          meta: {
            requiresAuth: true,
            title: '销售订单详情',
            roles: 'saleOrder:view'
          }
        }
      ]
    },
    {
      path: 'return-order',
      name: 'return-order-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'return-order-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'returnOrder',
        title: '退货单'
      },
      children: [
        {
          path: '',
          name: 'return-order-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 13 },
          meta: {
            requiresAuth: true,
            roles: 'returnOrder:view',
            title: '退货单'
          }
        },
        {
          path: ':id/collaborators',
          name: 'return-order-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 13 },
          meta: {
            requiresAuth: true,
            roles: 'returnOrder:view',
            title: '退货单详情'
          }
        },
        {
          path: ':id',
          name: 'return-order-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 13 },
          meta: {
            requiresAuth: true,
            roles: 'returnOrder:view',
            title: '退货单详情'
          }
        }
      ]
    }
  ]
};

export default ORDER;
